import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {FITHGameMode} from "../gameMode/FITHGameMode";
import {TimelineLite, TweenLite} from "gsap";
import {FITHParsedGameData} from "../server/data/FITHParsedGameData";
import {FITHGameConfig} from "../FITHGameConfig";
import {IDynamiteExtraValue} from "../server/data/IFITHServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {FITHSoundManager} from "../sound/FITHSoundManager";
import {FITHSoundConfig} from "../FITHSoundConfig";

export class FITHBonusGameReelStopPresentationController extends ReelStopPresentationController {
    private static bottomChestTl: TimelineLite;
    private static isAborted: boolean = false;
    private static lastTweenStarted: boolean;
    private static masterTl: TimelineLite;
    private static allCoinsTls: TimelineLite[] = [];
    private static allGoldBarTls: TimelineLite[] = [];
    private static bombTl: TimelineLite;
    private _canUpdateSpinsLeft: boolean = true;

    private static getAllVIndexVertical(i: number, positionsBefore: boolean[], newPositions: boolean[], allVIndex: number[]): void {
        for (let k: number = 1; k < (positionsBefore.length - 1); k++) {
            if (positionsBefore[k] || newPositions[k]) {
                allVIndex.push(i * FITHGameConfig.instance.REELS_NUM_ORIGINAL + k);
            }
        }
    }

    private static getAllVIndexRowWise(positionsBefore: boolean[][], newPositions: boolean[][], allVIndex: number[]): void {
        const multiplyBy: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;
        for (let j: number = 1; j < (positionsBefore.length - 1); j++) {
            for (let k: number = 0; k < positionsBefore.length; k++) {
                if (positionsBefore[k][j] || newPositions[k][j]) {
                    allVIndex.push((k * multiplyBy) + j);
                }
            }
        }
    }

    private static getAllVIndexForDwarfRowWise(bonusValuesAfterSpin: number[][], allVIndex: number[]): void {
        const multiplyBy: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;
        for (let j: number = 1; j < (bonusValuesAfterSpin.length - 1); j++) {
            for (let k: number = 0; k < bonusValuesAfterSpin.length; k++) {
                if (bonusValuesAfterSpin[k][j] > 0) {
                    allVIndex.push((k * multiplyBy) + j);
                }
            }
        }
    }

    private static tryBottomCollectorsAnimations(bottomCollectorActivated: boolean[], bonusValuesAfterSpin: number[][], dwarfReelId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (bottomCollectorActivated.indexOf(true) > -1) {
            for (let i: number = 0; i < bottomCollectorActivated.length; i++) {
                if (bottomCollectorActivated[i] && bonusValuesAfterSpin[i][5] > 0) {
                    tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForBottomCollectors(i, bonusValuesAfterSpin[i][5], dwarfReelId));
                }
            }
        }

        // #200
        if (this.isAborted || GameSetting.isFastSpin) {
            tl.timeScale(5);
        }
        this.bottomChestTl = tl;

        return tl;
    }

    private static tryBombAnimations(originalReels: number, bonusNewPositions: boolean[][], reels: string[][], explodePositions: boolean[][], dynamiteExtraValues: IDynamiteExtraValue[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let position: boolean[],
            reel: string[],
            checkForBSym: string[] = [];

        for (let i: number = 0; i < bonusNewPositions.length; i++) {
            position = bonusNewPositions[i];
            for (let j: number = 1; j < (position.length - 1); j++) {
                if (position[j]) {
                    reel = reels[i * originalReels];
                    checkForBSym = reel[0].split("B");

                    if (checkForBSym.length > 1) {
                        tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForBombEnhancer(explodePositions, i, checkForBSym[1], (i * originalReels + j), dynamiteExtraValues), 0);
                    }
                    break;
                }
            }
        }

        // #200
        if (this.isAborted || GameSetting.isFastSpin) {
            tl.timeScale(5);
        }
        this.bombTl = tl;

        return tl;
    }

    private static tryVerticalBagAnimations(originalReels: number, bonusNewPositions: boolean[][], reels: string[][], bonusPositionsBeforeSpin: boolean[][], bonusValuesAfterSpin: number[][]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let position: boolean[],
            reel: string[],
            checkForRSym: boolean = false;

        for (let i: number = 0; i < bonusNewPositions.length; i++) {
            position = bonusNewPositions[i];
            for (let j: number = 1; j < (position.length - 1); j++) {
                if (position[j]) {
                    reel = reels[i * originalReels];
                    checkForRSym = (reel[0] === "R1");

                    if (checkForRSym) {
                        const allVIndex: number[] = [],
                            totalMultiplier: number = bonusValuesAfterSpin[i][j];

                        FITHBonusGameReelStopPresentationController.getAllVIndexVertical(i, bonusPositionsBeforeSpin[i], bonusNewPositions[i], allVIndex);

                        return FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForBagCollect(i, allVIndex, totalMultiplier, (i * originalReels + j));
                    }
                    break;
                }
            }
        }

        return tl;
    }

    private static tryChestAnimations(originalReels: number, bonusNewPositions: boolean[][], reels: string[][], bonusPositionsBeforeSpin: boolean[][], bonusValuesAfterSpin: number[][]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let position: boolean[],
            reel: string[],
            checkForGSym: boolean = false;

        for (let i: number = 0; i < bonusNewPositions.length; i++) {
            position = bonusNewPositions[i];
            for (let j: number = 1; j < (position.length - 1); j++) {
                if (position[j]) {
                    reel = reels[i * originalReels];
                    checkForGSym = (reel[0] === "G");

                    if (checkForGSym) {
                        const allVIndex: number[] = [],
                            totalMultiplier: number = bonusValuesAfterSpin[i][j];

                        FITHBonusGameReelStopPresentationController.getAllVIndexRowWise(bonusPositionsBeforeSpin, bonusNewPositions, allVIndex);

                        return FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForChestEnhancer(i, allVIndex, totalMultiplier, (i * originalReels + j));
                    }
                    break;
                }
            }
        }

        return tl;
    }

    private static tryDwarfAnimations(originalReels: number, reels: string[][], bonusValuesAfterSpin: number[][], dwarfPosition: number[], anyBottomActive: boolean, secondDwarfPosition: number[], bonusNewPositions: boolean[][], bonusWinTimesBetAfter: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            checkForDWSym: boolean = (dwarfPosition[0] > -1);

        if (checkForDWSym) {
            const reel: string[] = reels[dwarfPosition[0] * originalReels],
                allVIndex: number[] = [],
                totalMultiplier: number = bonusValuesAfterSpin[dwarfPosition[0]][dwarfPosition[1]];
            let animateNewV: boolean = (reel[0] === "DW" && bonusNewPositions[dwarfPosition[0]].indexOf(true) > -1),
                doFast = (this.isAborted || GameSetting.isFastSpin) && !animateNewV,
                canActivateKilledDwarf: boolean = false;

            FITHBonusGameReelStopPresentationController.getAllVIndexForDwarfRowWise(bonusValuesAfterSpin, allVIndex);

            // #354
            if (secondDwarfPosition[0] > -1) {
                let totalOnBoard: number = 0;
                for (let i: number = 0; i < bonusValuesAfterSpin.length; i++) {
                    for (let j: number = 0; j < bonusValuesAfterSpin[i].length; j++) {
                        totalOnBoard += bonusValuesAfterSpin[i][j];
                    }
                }
                if (totalOnBoard < bonusWinTimesBetAfter) {
                    canActivateKilledDwarf = true;
                }

                animateNewV = doFast = false;
                tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateSecondDwarfEnhancer(secondDwarfPosition[0], ((secondDwarfPosition[0] * originalReels) + secondDwarfPosition[1]), canActivateKilledDwarf));
            }

            // there is an issue in the server that dwarf can get triggered when there was a coin already on the middle reels.
            // so in that case, it shouldn't animate if it is not new.
            if (!animateNewV && totalMultiplier === 0) {
                return tl;
            }

            tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForDwarfEnhancer(dwarfPosition[0], allVIndex, totalMultiplier, ((dwarfPosition[0] * originalReels) + dwarfPosition[1]), animateNewV, anyBottomActive, doFast));

            // #200
            if (doFast) {
                // #338, so that it doesn't impact the bottom chest, since both are using same flag.
                tl.add(() => FITHGameModuleConfig.bonusGameVSymbolOverlayView.isAborted = true, 0);

                // #321
                tl.timeScale(5);
            }
        }

        return tl;
    }

    public onReelSpinStopped(data: IReelStoppedData): void {
        const gameData: FITHParsedGameData = (this._gameData as FITHParsedGameData),
            originalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;
        let delay: number = 0.6;

        super.onReelSpinStopped && super.onReelSpinStopped(data);

        if (data.active && gameData && gameData.mode === FITHGameMode.BONUS && gameData.bonusNewPositions[Math.floor(data.reelId / originalReels)][(data.reelId % originalReels)]) {
            const reelIdModified: number = Math.floor((data.reelId / 6));

            // #145
            if (this._canUpdateSpinsLeft) {
                SlotGame.keypad.setZeroBetSpinCounter(3); // we want it to reset at 3.
                FITHGameModuleConfig.reelFrameView.updateSpinsLeftBoardText(3); // we want it to reset at 3.
                this._canUpdateSpinsLeft = false; // we want the update to happen only once per round.

                // #280
                FITHSoundManager.playFSSpinUpgrade();
            }

            if (data.reelId === FITHGameModuleConfig.spinController.getLastActiveReelInBonus()) {
                TweenLite.delayedCall(delay, () => {
                    FITHBonusGameReelStopPresentationController.lastTweenStarted = true;
                    const tl: TimelineLite = new TimelineLite();

                    tl.add(this.tryCoinMultiplierAnimations(originalReels, reelIdModified));
                    tl.add(this.tryGoldBarMultiplierAnimations(originalReels, reelIdModified));
                    tl.add(() => this.triggerAnimations(data.reelId));
                });
            } else {
                this.tryCoinMultiplierAnimations(originalReels, reelIdModified);
                this.tryGoldBarMultiplierAnimations(originalReels, reelIdModified);
                this.dispatchCompleteEvent(data.reelId);
            }

            FITHGameModuleConfig.spinController.disableBonusReel(data.reelId);
        } else if (gameData && gameData.mode === FITHGameMode.BONUS && data.reelId === FITHGameModuleConfig.spinController.getLastActiveReelInBonus()) {
            this.triggerAnimations(data.reelId);

            // #298
            FITHGameModuleConfig.bonusGameSpinNWagonAnimations.reelStoppedInBonus(data.reelId);
        } else {
            this.dispatchCompleteEvent(data.reelId);

            // #298
            if (gameData && gameData.mode === FITHGameMode.BONUS) {
                FITHGameModuleConfig.bonusGameSpinNWagonAnimations.reelStoppedInBonus(data.reelId);
            }
        }
    }

    // #200
    private static onStopSpin(): void {
        this.isAborted = true;

        if (this.allCoinsTls.length > 0 && !this.lastTweenStarted) {
            this.allCoinsTls.forEach((tl: TimelineLite) => {
                if (tl && tl.totalProgress() > 0 && tl.totalProgress() < 1) {
                    tl.totalProgress(1);
                }
            });
            this.allCoinsTls = [];
        }

        if (this.allGoldBarTls.length > 0 && !this.lastTweenStarted) {
            this.allGoldBarTls.forEach((tl: TimelineLite) => {
                if (tl && tl.totalProgress() > 0 && tl.totalProgress() < 1) {
                    tl.totalProgress(1);
                }
            });
            this.allGoldBarTls = [];
        }

        if (this.bombTl && this.bombTl.totalProgress() > 0 && this.bombTl.totalProgress() < 1) {
            this.bombTl.timeScale(5);
            if (this.masterTl) {
                // to avoid the halt, the masterTl gets due to above timeScale.
                this.masterTl.seek(this.bombTl.totalDuration(), false);
            }
        }

        if (this.bottomChestTl && this.bottomChestTl.totalProgress() > 0 && this.bottomChestTl.totalProgress() < 1) {
            // #284, #297
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.isAborted = true;

            this.bottomChestTl.timeScale(5);
            if (this.masterTl) {
                // to avoid the halt, the masterTl gets due to above timeScale.
                this.masterTl.seek(this.bottomChestTl.totalDuration(), false);
            }
        }
    }

    protected addFeatureEventHandlers() {
        super.addFeatureEventHandlers && super.addFeatureEventHandlers();

        EventHandler.addEventListener(this, SpinEvent.STOP, () => FITHBonusGameReelStopPresentationController.onStopSpin());
    }

    // #200
    protected resetFeature() {
        super.resetFeature && super.resetFeature();

        FITHBonusGameReelStopPresentationController.isAborted = false;
        FITHBonusGameReelStopPresentationController.lastTweenStarted = false;
        FITHBonusGameReelStopPresentationController.allCoinsTls = [];
        FITHBonusGameReelStopPresentationController.allGoldBarTls = [];
    }

    private tryCoinMultiplierAnimations(originalReels: number, reelId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            gameData: FITHParsedGameData = (this._gameData as FITHParsedGameData),
            bonusNewPositions: boolean[][] = gameData.bonusNewPositions,
            reels: string[][] = gameData.reels;

        let position: boolean[],
            reel: string[],
            checkForCSym: string[];

        position = bonusNewPositions[reelId];
        reel = reels[reelId * originalReels];
        checkForCSym = reel[0].split("C");
        for (let j: number = 1; j < (position.length - 1); j++) {
            if (position[j]) {
                if (checkForCSym.length > 1) {
                    tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForCoinMultiplier([reelId * originalReels + j], reelId, checkForCSym[1]), 0);
                    FITHBonusGameReelStopPresentationController.allCoinsTls.push(tl);
                }
                break;
            }
        }

        // #200
        if (FITHBonusGameReelStopPresentationController.isAborted || GameSetting.isFastSpin) {
            tl.timeScale(2);
        }

        return tl;
    }

    private tryGoldBarMultiplierAnimations(originalReels: number, reelId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            gameData: FITHParsedGameData = (this._gameData as FITHParsedGameData),
            bonusValuesAfterSpin: number[][] = gameData.bonusValuesAfterSpin,
            dwarfPosition: number[] = gameData.dwarfPosition,
            bonusNewPositions: boolean[][] = gameData.bonusNewPositions,
            bonusPositionsBeforeSpin: boolean[][] = gameData.bonusPositionsBeforeSpin,
            reels: string[][] = gameData.reels;

        let position: boolean[],
            reel: string[],
            checkForXSym: string[];

        position = bonusNewPositions[reelId];
        reel = reels[reelId * originalReels];
        checkForXSym = reel[0].split("X");
        for (let j: number = 1; j < (position.length - 1); j++) {
            if (position[j]) {
                if (checkForXSym.length > 1) {
                    const allVIndex: number[] = [];
                    let highestMultiplier: number = parseInt(checkForXSym[1]);
                    for (let i: number = 1; i < bonusValuesAfterSpin[reelId].length - 1; i++) {
                        if ((bonusValuesAfterSpin[reelId][i] > highestMultiplier) && (dwarfPosition[0] !== reelId || dwarfPosition[1] !== i)) {
                            highestMultiplier = bonusValuesAfterSpin[reelId][i];
                        }
                    }
                    FITHBonusGameReelStopPresentationController.getAllVIndexVertical(reelId, bonusPositionsBeforeSpin[reelId], bonusNewPositions[reelId], allVIndex);
                    tl.add(FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateForGoldBarMultiplier(allVIndex, reelId, checkForXSym[1], highestMultiplier), 0);
                    FITHBonusGameReelStopPresentationController.allGoldBarTls.push(tl);
                }
                break;
            }
        }

        // #200
        if (FITHBonusGameReelStopPresentationController.isAborted || GameSetting.isFastSpin) {
            tl.timeScale(2);
        }

        return tl;
    }

    private triggerAnimations(lastActiveReel: number): void {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => this.dispatchCompleteEvent(lastActiveReel)
            }),
            gameData: FITHParsedGameData = (this._gameData as FITHParsedGameData),
            bonusNewPositions: boolean[][] = gameData.bonusNewPositions,
            bonusPositionsBeforeSpin: boolean[][] = gameData.bonusPositionsBeforeSpin,
            bonusValuesAfterSpin: number[][] = gameData.bonusValuesAfterSpin,
            explodePositions: boolean[][] = gameData.explodePositions,
            fsMultiplierValueSoFar: number = gameData.bonusWinTimesBetAfter,
            reels: string[][] = gameData.reels,
            bottomCollectorActivated: boolean[] = gameData.bottomCollectorActivated,
            dwarfPosition: number[] = gameData.dwarfPosition,
            secondDwarfPosition: number[] = gameData.secondDwarfPos,
            dynamiteExtraValues: IDynamiteExtraValue[] = gameData.dynamiteExtraValues,
            originalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;

        // #145
        this._canUpdateSpinsLeft = true; // resetting it.

        // #278
        tl.add(() => {
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_REELS_SPINNING);
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_REELS_LANDING);
        }, 0);

        tl.add(FITHBonusGameReelStopPresentationController.tryBombAnimations(originalReels, bonusNewPositions, reels, explodePositions, dynamiteExtraValues));
        tl.add(FITHBonusGameReelStopPresentationController.tryBottomCollectorsAnimations(bottomCollectorActivated, bonusValuesAfterSpin, dwarfPosition[0]));
        tl.add([
            () => FITHGameModuleConfig.bonusGameSpinNWagonAnimations.highlightDwarfSpine(),
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.highlightAllV()
        ]);
        tl.add(FITHBonusGameReelStopPresentationController.tryVerticalBagAnimations(originalReels, bonusNewPositions, reels, bonusPositionsBeforeSpin, bonusValuesAfterSpin));
        tl.add(FITHBonusGameReelStopPresentationController.tryChestAnimations(originalReels, bonusNewPositions, reels, bonusPositionsBeforeSpin, bonusValuesAfterSpin));
        tl.add(FITHBonusGameReelStopPresentationController.tryDwarfAnimations(originalReels, reels, bonusValuesAfterSpin, dwarfPosition, (bottomCollectorActivated.indexOf(true) > -1), secondDwarfPosition, bonusNewPositions, fsMultiplierValueSoFar));

        tl.add(() => {
            for (let i: number = 0; i < originalReels; i++) {
                FITHGameModuleConfig.bonusGameSpinNWagonAnimations.dimWagon(i);
            }
        });

        tl.add(FITHGameModuleConfig.reelFrameView.updateTotalMultiplierBoardText(fsMultiplierValueSoFar));

        // #200
        FITHBonusGameReelStopPresentationController.masterTl = tl;
    }
}